/*
This is the registration file for custom components. The components should not be included here,
but only referenced. The sample component below can be used to start up working on your own custom
component.
*/
/*

In the sample-component.js you can define your own javascript functions etc for your custom component.
Then import the file here

import "./sample-component.js"
*/

// This file will import the css templates for your custom components

import "./components/index.js";
